import cn from "classnames";
import dynamic from "next/dynamic";
import React, { SVGProps, useMemo } from "react";
import semanticVariables from "../../styles/semantic_colors.module.scss";
import utilityVariables from "../../styles/utility_colors.module.scss";
import s from "./Icon.module.scss";

export enum IconNameList {
  AddSquareBold = "AddSquareBold",
  AddSquareRegular = "AddSquareRegular",
  AlertBold = "AlertBold",
  AlertRegular = "AlertRegular",
  AnnounceBold = "AnnounceBold",
  AnnounceRegular = "AnnounceRegular",
  Apartment2Bold = "Apartment2Bold",
  Apartment2Regular = "Apartment2Regular",
  ApartmentBold = "ApartmentBold",
  ApartmentRegular = "ApartmentRegular",
  ArrowDownBold = "ArrowDownBold",
  ArrowDownCircleBold = "ArrowDownCircleBold",
  ArrowDownCircleRegular = "ArrowDownCircleRegular",
  ArrowDownLeftBold = "ArrowDownLeftBold",
  ArrowDownLeftRegular = "ArrowDownLeftRegular",
  ArrowDownRegular = "ArrowDownRegular",
  ArrowDownRightBold = "ArrowDownRightBold",
  ArrowDownRightRegular = "ArrowDownRightRegular",
  ArrowLeftBold = "ArrowLeftBold",
  ArrowLeftCircleBold = "ArrowLeftCircleBold",
  ArrowLeftCircleRegular = "ArrowLeftCircleRegular",
  ArrowLeftDownCircleBold = "ArrowLeftDownCircleBold",
  ArrowLeftDownCircleRegular = "ArrowLeftDownCircleRegular",
  ArrowLeftRegular = "ArrowLeftRegular",
  ArrowLeftUpCircleBold = "ArrowLeftUpCircleBold",
  ArrowLeftUpCircleRegular = "ArrowLeftUpCircleRegular",
  ArrowRightBold = "ArrowRightBold",
  ArrowRightCircleBold = "ArrowRightCircleBold",
  ArrowRightCircleRegular = "ArrowRightCircleRegular",
  ArrowRightDownCircleBold = "ArrowRightDownCircleBold",
  ArrowRightDownCircleRegular = "ArrowRightDownCircleRegular",
  ArrowRightRegular = "ArrowRightRegular",
  ArrowRightUpCircleBold = "ArrowRightUpCircleBold",
  ArrowRightUpCircleRegular = "ArrowRightUpCircleRegular",
  ArrowTrendingDownBold = "ArrowTrendingDownBold",
  ArrowTrendingDownRegular = "ArrowTrendingDownRegular",
  ArrowTrendingUpBold = "ArrowTrendingUpBold",
  ArrowTrendingUpRegular = "ArrowTrendingUpRegular",
  ArrowUpBold = "ArrowUpBold",
  ArrowUpCircleBold = "ArrowUpCircleBold",
  ArrowUpCircleRegular = "ArrowUpCircleRegular",
  ArrowUpLeftBold = "ArrowUpLeftBold",
  ArrowUpLeftRegular = "ArrowUpLeftRegular",
  ArrowUpRegular = "ArrowUpRegular",
  ArrowUpRightBold = "ArrowUpRightBold",
  ArrowUpRightRegular = "ArrowUpRightRegular",
  AtRegular = "AtRegular",
  BadgeBold = "BadgeBold",
  BadgeRegular = "BadgeRegular",
  BagBold = "BagBold",
  BagCheckBold = "BagCheckBold",
  BagCheckRegular = "BagCheckRegular",
  BagRegular = "BagRegular",
  BankBold = "BankBold",
  BankRegular = "BankRegular",
  BikeBold = "BikeBold",
  BikeRegular = "BikeRegular",
  BillList1 = "BillList1",
  Bolt2Bold = "Bolt2Bold",
  Bolt2Regular = "Bolt2Regular",
  Bookmark1Bold = "Bookmark1Bold",
  Bookmark1Regular = "Bookmark1Regular",
  Bookmark2Bold = "Bookmark2Bold",
  Bookmark2Regular = "Bookmark2Regular",
  BuildingBold = "BuildingBold",
  BuildingRegular = "BuildingRegular",
  BulbBold = "BulbBold",
  BulbRegular = "BulbRegular",
  BurgerMenuBold = "BurgerMenuBold",
  BurgerMenuRegular = "BurgerMenuRegular",
  CalculatorBold = "CalculatorBold",
  CalculatorRegular = "CalculatorRegular",
  CalenderBold = "CalenderBold",
  CalenderRegular = "CalenderRegular",
  CameraBold = "CameraBold",
  CameraRegular = "CameraRegular",
  CancelCallBold = "CancelCallBold",
  CancelCallRegular = "CancelCallRegular",
  CarAddBold = "CarAddBold",
  CarAddRegular = "CarAddRegular",
  CarBold = "CarBold",
  CarFilledBold = "CarFilledBold",
  CarFilledRegular = "CarFilledRegular",
  CarMinusBold = "CarMinusBold",
  CarMinusRegular = "CarMinusRegular",
  CarRegular = "CarRegular",
  CardBold = "CardBold",
  CardRegular = "CardRegular",
  CartBold = "CartBold",
  CartRegular = "CartRegular",
  CashBold = "CashBold",
  CashRegular = "CashRegular",
  CertificateBold = "CertificateBold",
  CertificateRegular = "CertificateRegular",
  ChatBubbleBold = "ChatBubbleBold",
  ChatBubbleDotsBold = "ChatBubbleDotsBold",
  ChatBubbleDotsRegular = "ChatBubbleDotsRegular",
  ChatBubbleGroupBold = "ChatBubbleGroupBold",
  ChatBubbleGroupRegular = "ChatBubbleGroupRegular",
  ChatBubbleLikeBold = "ChatBubbleLikeBold",
  ChatBubbleLikeRegular = "ChatBubbleLikeRegular",
  ChatBubbleReadBold = "ChatBubbleReadBold",
  ChatBubbleReadRegular = "ChatBubbleReadRegular",
  ChatBubbleRegular = "ChatBubbleRegular",
  CheckCircleBold = "CheckCircleBold",
  CheckCircleRegular = "CheckCircleRegular",
  CheckSquareBold = "CheckSquareBold",
  CheckSquareRegular = "CheckSquareRegular",
  ChevronDownBold = "ChevronDownBold",
  ChevronDownRegular = "ChevronDownRegular",
  ChevronLeftBold = "ChevronLeftBold",
  ChevronLeftRegular = "ChevronLeftRegular",
  ChevronRightBold = "ChevronRightBold",
  ChevronRightRegular = "ChevronRightRegular",
  ChevronUpBold = "ChevronUpBold",
  ChevronUpRegular = "ChevronUpRegular",
  CityBold = "CityBold",
  CityRegular = "CityRegular",
  ClockBold = "ClockBold",
  ClockRegular = "ClockRegular",
  CloseSquareBold = "CloseSquareBold",
  CloseSquareRegular = "CloseSquareRegular",
  CompassBold = "CompassBold",
  CompassRegular = "CompassRegular",
  ConfettiBold = "ConfettiBold",
  ContactsBold = "ContactsBold",
  ContactsRegular = "ContactsRegular",
  CopyBold = "CopyBold",
  CopyRegular = "CopyRegular",
  CrossBold = "CrossBold",
  CrossCircleBold = "CrossCircleBold",
  CrossCircleRegular = "CrossCircleRegular",
  CrossRegular = "CrossRegular",
  CrownBold = "CrownBold",
  CrownRegular = "CrownRegular",
  DecoratedArrow = "DecoratedArrow",
  DirectionBold = "DirectionBold",
  DirectionRegular = "DirectionRegular",
  DiscountBold = "DiscountBold",
  Dot = "Dot",
  DoubleTickBold = "DoubleTickBold",
  DoubleTickRegular = "DoubleTickRegular",
  DownloadBold = "DownloadBold",
  DownloadRegular = "DownloadRegular",
  Edit2Bold = "Edit2Bold",
  Edit2Regular = "Edit2Regular",
  EditBold = "EditBold",
  EditRegular = "EditRegular",
  EssentialsBold = "EssentialsBold",
  EssentialsRegular = "EssentialsRegular",
  ExclaimationCircleBold = "ExclaimationCircleBold",
  ExclaimationCircleRegular = "ExclaimationCircleRegular",
  EyeBold = "EyeBold",
  EyeClosedBold = "EyeClosedBold",
  EyeClosedRegular = "EyeClosedRegular",
  EyeRegular = "EyeRegular",
  FileAddBold = "FileAddBold",
  FileAddRegular = "FileAddRegular",
  FileBold = "FileBold",
  FileCheckBold = "FileCheckBold",
  FileCheckRegular = "FileCheckRegular",
  FileLockedBold = "FileLockedBold",
  FileLockedRegular = "FileLockedRegular",
  FilePdfBold = "FilePdfBold",
  FilePdfRegular = "FilePdfRegular",
  FileRegular = "FileRegular",
  FileRemoveBold = "FileRemoveBold",
  FileRemoveRegular = "FileRemoveRegular",
  FileWarningBold = "FileWarningBold",
  FileWarningRegular = "FileWarningRegular",
  FilterBold = "FilterBold",
  FilterRegular = "FilterRegular",
  Flag2Bold = "Flag2Bold",
  Flag2Regular = "Flag2Regular",
  FlagBold = "FlagBold",
  FlagRegular = "FlagRegular",
  FlashBold = "FlashBold",
  FlashRegular = "FlashRegular",
  FolderBold = "FolderBold",
  FolderRegular = "FolderRegular",
  FoodBold = "FoodBold",
  FoodRegular = "FoodRegular",
  FuelMeterBold = "FuelMeterBold",
  FuelMeterRegular = "FuelMeterRegular",
  FuelStationBold = "FuelStationBold",
  FuelStationRegular = "FuelStationRegular",
  GPS = "GPS",
  GarageBold = "GarageBold",
  GarageRegular = "GarageRegular",
  GateBold = "GateBold",
  GateRegular = "GateRegular",
  GiftBold = "GiftBold",
  GiftRegular = "GiftRegular",
  GiftTopBold = "GiftTopBold",
  GiftTopRegular = "GiftTopRegular",
  GlobeBold = "GlobeBold",
  GlobeRegular = "GlobeRegular",
  HeartBold = "HeartBold",
  HeartRegular = "HeartRegular",
  HelpAndSupportBold = "HelpAndSupportBold",
  HelpAndSupportRegular = "HelpAndSupportRegular",
  HistoryBold = "HistoryBold",
  HistoryRegular = "HistoryRegular",
  HomeBold = "HomeBold",
  HomeRegular = "HomeRegular",
  ImageBold = "ImageBold",
  ImageRegular = "ImageRegular",
  IncomingCallBold = "IncomingCallBold",
  IncomingCallRegular = "IncomingCallRegular",
  IndiaLetters = "IndiaLetters",
  Info2CircleBold = "Info2CircleBold",
  Info2CircleRegular = "Info2CircleRegular",
  InfoCircleBold = "InfoCircleBold",
  InfoCircleRegular = "InfoCircleRegular",
  KebabMenuBold = "KebabMenuBold",
  KebabMenuRegular = "KebabMenuRegular",
  KeyBold = "KeyBold",
  KeyRegular = "KeyRegular",
  Link1Bold = "Link1Bold",
  Link1Regular = "Link1Regular",
  LocationBold = "LocationBold",
  LocationRegular = "LocationRegular",
  LockBold = "LockBold",
  LockOpenBold = "LockOpenBold",
  LockOpenRegular = "LockOpenRegular",
  LockRegular = "LockRegular",
  LogoutRightBold = "LogoutRightBold",
  LogoutRightRegular = "LogoutRightRegular",
  LongArrowDownBold = "LongArrowDownBold",
  LongArrowDownRegular = "LongArrowDownRegular",
  LongArrowLeftBold = "LongArrowLeftBold",
  LongArrowLeftRegular = "LongArrowLeftRegular",
  LongArrowRightBold = "LongArrowRightBold",
  LongArrowRightRegular = "LongArrowRightRegular",
  LongArrowUpBold = "LongArrowUpBold",
  LongArrowUpRegular = "LongArrowUpRegular",
  MailBold = "MailBold",
  MailOpenBold = "MailOpenBold",
  MailOpenRegular = "MailOpenRegular",
  MailRegular = "MailRegular",
  MeatballMenuBold = "MeatballMenuBold",
  MeatballMenuCircleBold = "MeatballMenuCircleBold",
  MeatballMenuCircleRegular = "MeatballMenuCircleRegular",
  MeatballMenuRegular = "MeatballMenuRegular",
  MedalStarBold = "MedalStarBold",
  MedalStarRegular = "MedalStarRegular",
  MegaPhone = "MegaPhone",
  MessageBold = "MessageBold",
  MessageDotsBold = "MessageDotsBold",
  MessageDotsRegular = "MessageDotsRegular",
  MessageGroupBold = "MessageGroupBold",
  MessageGroupRegular = "MessageGroupRegular",
  MessageLikeBold = "MessageLikeBold",
  MessageLikeRegular = "MessageLikeRegular",
  MessageReadBold = "MessageReadBold",
  MessageReadRegular = "MessageReadRegular",
  MessageRegular = "MessageRegular",
  MicrophoneBold = "MicrophoneBold",
  MicrophoneRegular = "MicrophoneRegular",
  MinuBold = "MinuBold",
  MinuRegular = "MinuRegular",
  MinusCircleBold = "MinusCircleBold",
  MinusCircleRegular = "MinusCircleRegular",
  MinusSquareBold = "MinusSquareBold",
  MinusSquareRegular = "MinusSquareRegular",
  NavigateBold = "NavigateBold",
  NavigateRegular = "NavigateRegular",
  NotebookBold = "NotebookBold",
  NotebookRegular = "NotebookRegular",
  NotificationBold = "NotificationBold",
  NotificationRegular = "NotificationRegular",
  NotificationSilentBold = "NotificationSilentBold",
  NotificationSilentRegular = "NotificationSilentRegular",
  NotificationTickBold = "NotificationTickBold",
  NotificationTickRegular = "NotificationTickRegular",
  NounLimit = "NounLimit",
  Offer2Bold = "Offer2Bold",
  Offer2Regular = "Offer2Regular",
  OfferBold = "OfferBold",
  OfferRegular = "OfferRegular",
  PaperclipBold = "PaperclipBold",
  PaperclipRegular = "PaperclipRegular",
  ParkPlusVerifiedBold = "Park+VerifiedBold",
  ParkPlusVerifiedRegular = "Park+VerifiedRegular",
  ParkVerifiedBold = "ParkVerifiedBold",
  ParkVerifiedRegular = "ParkVerifiedRegular",
  PauseBold = "PauseBold",
  PauseRegular = "PauseRegular",
  PercentageBold = "PercentageBold",
  PercentageRegular = "PercentageRegular",
  PhoneBold = "PhoneBold",
  PhoneCallingBold = "PhoneCallingBold",
  PhoneCallingRegular = "PhoneCallingRegular",
  PhoneRegular = "PhoneRegular",
  PlayBold = "PlayBold",
  PlayRegular = "PlayRegular",
  PlusBold = "PlusBold",
  PlusCircleBold = "PlusCircleBold",
  PlusCircleRegular = "PlusCircleRegular",
  PlusRegular = "PlusRegular",
  QrCodeBold = "QrCodeBold",
  QrCodeRegular = "QrCodeRegular",
  QuestionCircleBold = "QuestionCircleBold",
  QuestionCircleRegular = "QuestionCircleRegular",
  RefreshBold = "RefreshBold",
  RefreshRegular = "RefreshRegular",
  RestartBold = "RestartBold",
  RestartRegular = "RestartRegular",
  RestrictBold = "RestrictBold",
  RestrictRegular = "RestrictRegular",
  RevokeBold = "RevokeBold",
  RevokeRegular = "RevokeRegular",
  RocketBold = "RocketBold",
  RocketRegular = "RocketRegular",
  RoundDownArrowCircleBold = "RoundDownArrowCircleBold",
  RoundDownArrowCircleRegular = "RoundDownArrowCircleRegular",
  RoundLeftArrowCircleBold = "RoundLeftArrowCircleBold",
  RoundLeftArrowCircleRegular = "RoundLeftArrowCircleRegular",
  RoundRightArrowCircleBold = "RoundRightArrowCircleBold",
  RoundRightArrowCircleRegular = "RoundRightArrowCircleRegular",
  RoundUpArrowCircleBold = "RoundUpArrowCircleBold",
  RoundUpArrowCircleRegular = "RoundUpArrowCircleRegular",
  RoutingBold = "RoutingBold",
  RupeeBold = "RupeeBold",
  RupeeRegular = "RupeeRegular",
  SearchBold = "SearchBold",
  SearchCircleBold = "SearchCircleBold",
  SearchCircleRegular = "SearchCircleRegular",
  SearchRegular = "SearchRegular",
  SecurityScanner = "SecurityScanner",
  SendBold = "SendBold",
  SendRegular = "SendRegular",
  SettingsBold = "SettingsBold",
  SettingsRegular = "SettingsRegular",
  Share1Bold = "Share1Bold",
  Share1Regular = "Share1Regular",
  ShareBold = "ShareBold",
  ShareMultipleBold = "ShareMultipleBold",
  ShareMultipleRegular = "ShareMultipleRegular",
  ShareRegular = "ShareRegular",
  ShieldBold = "ShieldBold",
  ShieldCheckBold = "ShieldCheckBold",
  ShieldCheckRegular = "ShieldCheckRegular",
  ShieldCrossBold = "ShieldCrossBold",
  ShieldCrossRegular = "ShieldCrossRegular",
  ShieldRegular = "ShieldRegular",
  ShieldUserBold = "ShieldUserBold",
  ShieldUserRegular = "ShieldUserRegular",
  ShieldWarningBold = "ShieldWarningBold",
  ShieldWarningRegular = "ShieldWarningRegular",
  Shop1Bold = "Shop1Bold",
  Shop1Regular = "Shop1Regular",
  Shop2Bold = "Shop2Bold",
  Shop2Regular = "Shop2Regular",
  SortHorizontalBold = "SortHorizontalBold",
  SortHorizontalRegular = "SortHorizontalRegular",
  SortVerticleBold = "SortVerticleBold",
  SortVerticleRegular = "SortVerticleRegular",
  SpeedometerBold = "SpeedometerBold",
  SpeedometerRegular = "SpeedometerRegular",
  StackBold = "StackBold",
  StackRegular = "StackRegular",
  StarBold = "StarBold",
  StarCircleBold = "StarCircleBold",
  StarCircleRegular = "StarCircleRegular",
  StarRegular = "StarRegular",
  StarsBold = "StarsBold",
  StarsInCircle = "StarsInCircle",
  StarsRegular = "StarsRegular",
  SteeringBold = "SteeringBold",
  SteeringRegular = "SteeringRegular",
  ThumbsUpBold = "ThumbsUpBold",
  ThumbsUpRegular = "ThumbsUpRegular",
  TickBold = "TickBold",
  TickCircleBold = "TickCircleBold",
  TickCircleRegular = "TickCircleRegular",
  TickRegular = "TickRegular",
  TicketBold = "TicketBold",
  TicketRegular = "TicketRegular",
  ToolBold = "ToolBold",
  ToolRegular = "ToolRegular",
  TrashBold = "TrashBold",
  TrashRegular = "TrashRegular",
  TrophyFirstBold = "TrophyFirstBold",
  TrophyFirstRegular = "TrophyFirstRegular",
  TrophyStarBold = "TrophyStarBold",
  TrophyStarRegular = "TrophyStarRegular",
  TruckBold = "TruckBold",
  TruckRegular = "TruckRegular",
  UpiBold = "UpiBold",
  UpiRegular = "UpiRegular",
  UploadBold = "UploadBold",
  UploadRegular = "UploadRegular",
  UserAddBold = "UserAddBold",
  UserAddRegular = "UserAddRegular",
  UserBlock = "UserBlock",
  UserBold = "UserBold",
  UserCheckBold = "UserCheckBold",
  UserGroup1Bold = "UserGroup1Bold",
  UserGroup1Regular = "UserGroup1Regular",
  UserGroup2Bold = "UserGroup2Bold",
  UserGroup2Regular = "UserGroup2Regular",
  UserIdBold = "UserIdBold",
  UserIdRegular = "UserIdRegular",
  UserProfileBold = "UserProfileBold",
  UserProfileRegular = "UserProfileRegular",
  UserRegular = "UserRegular",
  UserSyncBold = "UserSyncBold",
  UserSyncRegular = "UserSyncRegular",
  UserVerifiedCircleBold = "UserVerifiedCircleBold",
  UserVerifiedCircleRegular = "UserVerifiedCircleRegular",
  VerifiedCheckBold = "VerifiedCheckBold",
  VerifiedCheckRegular = "VerifiedCheckRegular",
  VideoBold = "VideoBold",
  VideoRegular = "VideoRegular",
  VolumeBold = "VolumeBold",
  VolumeOffBold = "VolumeOffBold",
  VolumeOffRegular = "VolumeOffRegular",
  VolumeRegular = "VolumeRegular",
  Whatsapp = "Whatsapp",
  WhatsappIcon = "WhatsappIcon",
  WidgetAddBold = "WidgetAddBold",
  WidgetAddRegular = "WidgetAddRegular",
  WidgetBold = "WidgetBold",
  WidgetRegular = "WidgetRegular",
  XtraRewards = "XtraRewards",
  FuelDrop = "FuelDrop",
  LikeBold = "LikeBold",
  LogoutRegular = "LogoutRegular",
  ListRegular = "ListRegular",
  DocumentBold = "DocumentBold",
  UnlikeBold = "UnlikeBold",
  UnlikeRegular = "UnlikeRegular",
  DropBold = "DropBold",
  CupStarRegular = "CupStarRegular",
  HeadphoneRegular = "HeadphoneRegular"
}

export type IconName = keyof typeof IconNameList;

export interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  width = 24,
  height = 24,
  color = "primary",
  className,
  ...rest
}) => {
  const colorValue =
    semanticVariables?.[`semantic_icon_${color}`] ||
    utilityVariables?.[`utility_icon_${color}`] ||
    semanticVariables?.[color];

  const DynamicIcon = useMemo(() => {
    return dynamic(
      () =>
        import(`../../assets/svgs/${name}.svg`).then(
          (mod) => mod as unknown as React.FC<SVGProps<SVGSVGElement>>
        ),
      {
        ssr: false,
        loading: () => (
          <span
            className={cn(s.shimmer, "cmn_shimmer")}
            style={{
              width,
              height,
            }}
          />
        ),
      }
    );
  }, [name, width, height]);

  return (
    <DynamicIcon
      width={width}
      height={height}
      fill={colorValue}
      className={className}
      {...rest}
    />
  );
};

export default Icon;
